import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/V1/PhotoAlbum'

const PhotoAlbum = {
  PageData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PageData`,
      data
    })
  },
  Create(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Create`,
      data
    })
  },
  Detail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}`,
      params
    })
  },
  SetSort(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/SetSort`,
      data
    })
  },
  Delete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Delete`,
      data
    })
  }
}

export default PhotoAlbum
